<script>
import { layoutComputed } from "@/state/helpers";
//import Vertical from "./vertical";
 import Horizontal from "./horizontal";

export default {
  components: { /*Vertical*/  Horizontal },
  computed: {
    ...layoutComputed
  },
  methods: {}
};
</script>

<template>
  <div>
    <Horizontal v-if="layoutType === 'vertical'" :layout="layoutType" class="">
      <slot />
    </Horizontal>
    <!-- <h5 class="d-lg-none p-4 m-4 font-weight-bol d-print-none font-size-16">
      Mobile devices are not supported in this Beta-Version
    </h5> -->
  </div>
</template>
